module.exports = __webpack_public_path__ + "media/public/img/tripadvisor-round-color-01-c2602b701674d379597ad6f140e4ef40.svg";